import React from 'react'
import { Button, Tag, Typography } from 'antd'
import { CompareFieldKey, CompareRow, isAppliable } from './compare'

const { Text } = Typography

type Props = {
  row?: CompareRow
  applied: boolean
  onApply: (row: CompareRow) => void
}

const isRawEmpty = (v: unknown): boolean =>
  v === null || v === undefined || String(v).trim() === ''

export const AutoCheckHint = ({ row, applied, onApply }: Props) => {
  if (!row) return null
  if (applied) {
    return (
      <Tag color="success" style={{ fontSize: 11, marginTop: 4 }}>
        applied from document
      </Tag>
    )
  }
  if (row.match) {
    if (isRawEmpty(row.docRawValue)) return null
    return (
      <Tag color="success" style={{ fontSize: 11, marginTop: 4 }}>
        matches document
      </Tag>
    )
  }
  if (isAppliable(row)) {
    return (
      <div style={{ marginTop: 4, fontSize: 12 }}>
        <Text type="warning" style={{ fontSize: 12 }}>
          Document: {row.docValue}
        </Text>
        <Button
          size="small"
          type="link"
          style={{ paddingLeft: 8 }}
          onClick={() => onApply(row)}
        >
          Apply
        </Button>
      </div>
    )
  }
  if (row.status === 'missing_in_doc') {
    return (
      <Tag style={{ fontSize: 11, marginTop: 4 }}>not on document</Tag>
    )
  }
  if (row.status === 'missing_in_crm') {
    return (
      <Tag color="processing" style={{ fontSize: 11, marginTop: 4 }}>
        missing in CRM
      </Tag>
    )
  }
  return null
}

export const isFieldMismatch = (row?: CompareRow): boolean =>
  Boolean(row && isAppliable(row))

export type { CompareFieldKey }
